import React from 'react';
import { Card, Typography } from 'antd';
// Styles
import styles from './CurrentOwnerCard.module.scss';

const { Text } = Typography;

type CurrentOwnerCardProps = {
  ownerId: string;
  teamLabel?: string | null;
  sourceOwnsTeam: boolean;
};

const CurrentOwnerCard = ({
  ownerId,
  teamLabel,
  sourceOwnsTeam,
}: CurrentOwnerCardProps): JSX.Element => (
  <Card className={styles.sourceCard} title="Current owner">
    <div className={styles.sourceMeta}>
      <div>
        Account:
        <span className={styles.value}>{ownerId}</span>
      </div>
      {sourceOwnsTeam && (
        <div>
          Team:
          <span className={styles.value}>{teamLabel || '—'}</span>
        </div>
      )}
      <Text type="secondary">
        The current owner must already have a team. After a successful transfer,
        previewing again will show that they no longer own one. To undo, run the
        transfer the other way.
      </Text>
    </div>
  </Card>
);

export default CurrentOwnerCard;
